import { Box } from '@mui/material';
import NavLink from './NavLink';
import GroupedMenu from './GroupedMenu';

export default function NavMenuDesktop({
    navigationItems,
    navigationGrouped,
    resources,
    handlePathDirection
}) {
    return (
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {navigationItems.map((item, index) => (
                <NavLink key={index} path={item} handlePathDirection={handlePathDirection} />
            ))}

            {navigationGrouped.length > 0 && (
                <GroupedMenu
                    groupedItems={navigationGrouped}
                    label={resources.words.MANAGEMENT}
                    handlePathDirection={handlePathDirection}
                />
            )}
        </Box>
    );
}